import React from 'react';
import { Box, BoxProps, FormError, MultiCombobox, MultiComboboxProps } from 'pounceV2';
import { FieldConfig } from 'formik';
import useFastField from 'Hooks/useFastField';
import { safeguardErrorMsg } from '../utils';

function FormikMultiComboboxV3<T>(
  props: MultiComboboxProps<T> &
    Required<Pick<FieldConfig, 'name'>> & {
      overrideOnChange?: (value: T[]) => void;
      containerProps?: BoxProps;
    },
): React.ReactNode {
  const { overrideOnChange, containerProps, ...multiComboboxProps } = props;
  const [, meta, { setValue }] = useFastField(props.name);

  // Allow explicit invalid prop to override field validation state
  const fieldIsInvalid = meta.touched && !!meta.error;
  const isInvalid = props.invalid !== undefined ? props.invalid : fieldIsInvalid;
  const errorElementId = isInvalid ? `${props.name}-error` : undefined;
  const value = props.value?.map ? props.value : [];

  // Overriding setValue to allow for custom onChange behavior
  const onChange = overrideOnChange ?? setValue;

  return (
    <Box {...(containerProps || {})}>
      <MultiCombobox
        {...multiComboboxProps}
        value={value}
        invalid={isInvalid}
        aria-describedby={isInvalid ? errorElementId : undefined}
        onChange={onChange}
      />
      {fieldIsInvalid && (
        <FormError mt={2} id={errorElementId} data-testid={errorElementId}>
          {safeguardErrorMsg(meta.error)}
        </FormError>
      )}
    </Box>
  );
}

export default FormikMultiComboboxV3;
